/**
 * Per-collection gating for the Strapi → Nuxt Content migration.
 *
 * Each key gates one logical collection. When the master `enableNuxtContent`
 * flag is true it forces every key on, preserving the original brand-wide
 * switch for brands that haven't migrated to per-collection flags.
 */

export type ContentMigrationKey
    = | 'generalConsents'
        | 'consents'
        | 'faq'
        | 'pages'
        | 'gamePages'
        | 'press'

interface FlagsShape {
    enableNuxtContent?: boolean
    contentMigration?: Partial<Record<ContentMigrationKey, boolean>>
}

export function useContentMigrationFlag(key: ContentMigrationKey): boolean {
    try {
        const config = useRuntimeConfig()
        const flags = config.public?.flags as FlagsShape | undefined
        if (flags?.enableNuxtContent === true) return true
        return flags?.contentMigration?.[key] === true
    }
    catch {
        return false
    }
}
